import { FC, useEffect, useMemo, useRef } from "react";
import { useApp } from "../../../context/useApp";
import { ShiftSelection } from "../../ShiftSelection";
import { ProductsSelection } from "../../ProductsSelection";
import { Summary } from "./Summary";
import { _, load } from "../../../utils/helpers";
import { Zones } from "./Zones";
import { Icon } from "../../../parts/Icon";
import { DEFAULT_BOOKING_INSTRUCTIONS, ROUTES, SCREEN_BREAKPOINT_2 } from "../../../utils/symbols";

export const Aside: FC = () => {

    const {
        state: {screen, booking, forcedRenders },
        actions: { navigate }
    } = useApp()

    const asideContentRef = useRef<HTMLDivElement>(null)
    const lastBookingStep = useRef(booking.step)
    const renderTicketInstructions = useMemo(() => {

        // change: show always
        // const { ticketsShown } = load('localStorage', 'booking-instructions', DEFAULT_BOOKING_INSTRUCTIONS)
        return booking.step === 'tickets' && booking.pax === 0

    }, [forcedRenders])
    
    const renderShiftSelction = (booking.step === 'shift')
    const renderZones = (booking.step === 'tickets')
    const renderProductsSelection = (['products', 'personal-details', 'payment'].includes(booking.step))
    const renderSummary = (['tickets', 'products'].includes(booking.step))

    useEffect(() => {
        
        //reset aside scroll to top when changing step
        if (booking.step !== lastBookingStep.current && asideContentRef.current)
            asideContentRef.current.scrollTo({top: 0, left: 0, behavior: 'smooth'})

        lastBookingStep.current = booking.step

    }, [forcedRenders])

    return (
        <>
        <div 
            className={`df fd-c aifs aside pb-12 h-100 p-r ${renderTicketInstructions ? 'ticket-instructions-rendered' : ''}`}
            // aria-label={ariaLabel}
        >
            <div className={`ticket-instructions df aic p-a ${renderTicketInstructions ? 'ticket-instructions-rendered' : ''}`}>
                <Icon icon="slab" className="p-a"/>
                <Icon icon="pointer" className="p-a"/>
                <p className="instruction-text">{_('3zo_selec_z')}</p>
            </div>
            <div ref={asideContentRef} className="w-100 h-100 aside-content px-10">
                {renderShiftSelction && (<ShiftSelection />)}
                {renderZones && (<Zones />)}
                {renderProductsSelection && (<ProductsSelection />)}
            </div>
        </div>
        {renderSummary && (<Summary />)}
        </>
    )
}